import RedeemedMNCLayout from "./RedeemedMNCLayout";
import RedeemedVoucherReportPage from "./pages/RedeemedVoucherReportPage";
import HomeDiscountVoucherReportPage from "./pages/HomeDiscountVoucherReportPage";

export const RedeemedMNCPathRoutes = () => [
  {
    name: "RedeemedVoucherReportPage",
    path: "redeemed-voucher-report",
    component: RedeemedVoucherReportPage
  },
  {
    name: "HomeDiscountVoucherReportPage",
    path: "home-discount-voucher-report",
    component: HomeDiscountVoucherReportPage
  }
];

export const redeemedMNCRoutes = {
  path: "redeemed-mnc",
  component: RedeemedMNCLayout,
  children: [
    ...RedeemedMNCPathRoutes()
  ]
};
